import React, {Component} from 'react';
import {Route, Switch, Redirect,} from "react-router-dom";
import { setNavigateToLogin } from '../service/httpBase';
/*城际相关路由 */
//路由
import Home from '../container/Home';
import Login from '../container/Login';
import PassengerInfo from './Home/PassengerInfo';//乘客详情
import SelectShift from './Member/SelectShift';//改签选择行程
import OrderChange from './Member/OrderChange';//改签
import News from './Member/News';//消息
import ShuntOrderList from './Member/ShuntOrderList';//分流下单记录
import CityOrderList from './Member/CityOrderList';//城内下单记录
import PickHistory from './Member/PickHistory';//接驳历史记录
import ShuntList from './Member/ShuntList';//分流下单组合后记录(多条)
import ReplaceOrderList from './Member/ReplaceOrderList';//代客下单记录
import HistoryShift from './Member/HistoryShift';//历史行程记录
import ReplaceOrderInfo from './Member/ReplaceOrderInfo';//代客下单详情
import FrequentlyPassenger from './Member/FrequentlyPassenger';//常用乘车人
import AddFrequentlyPassenger from './Member/AddFrequentlyPassenger';//添加常用乘车人
import RefundTicket from './Home/RefundTicket';//退票
import SelAddress from './Home/SelAddress';//选择地址
import ChangeAddress from './Home/ChangeAddress';//修改上下车地址
import SelectAddress from '../container/Home/changeRole/Shunt/SelectAddress';//分流选择地址
import TwoDimensionalCode from './Home/TwoDimensionalCode';//修改地址扫描二维码支付
import TwoDimensional from './Member/TwoDimensional';//设置里面的二维码
import PaySuccess from './Home/PaySuccess';//修改上下车地址
import RefundApply from './Member/RefundApply';//退款详情
import ApplyInvoice from './Invoice/ApplyInvoice';//发票选项
import Invoice from '../container/Invoice';//发票申请
import InvoiceInfo from './Invoice/InvoiceInfo'//申请发票
import InvoiceHistory from './Invoice/InvoiceHistory'// 发票历史
import InvoiceSucceed from './Invoice/InvoiceSucceed'// 发票申请成功
import paperInvoice from './Invoice/paperInvoice';//电子纸质发票详情
import DataStatistics from '../container/Home/Index/DataStatistics';//数据统计
import WaterBill from '../container/Home/Index/WaterBill';//流水账单
import DealList from '../container/Home/Index/DealList';//流水账单交易列表
import DealDetail from '../container/Home/Index/DealDetail';//流水账单交易详情
import ShuntOrder from '../container/Home/changeRole/Shunt/shuntOrder';//分流下单
import ShiftDetails from './Shift/ShiftDetails';//行程详情
import PassengerList from './Shift/PassengerList';//乘客明细列表
import BringGoodList from './Shift/BringGoodsList';//带货列表
import AddShift from './AddShift';//添加行程
import ResetPwd from './Login/ResetPwd';//重置密码输入手机号
import GetCode from './Login/getCode';//获取验证码
import SetPwd from './Login/SetPwd';//重置密码
import AddPassengers from './Shift/AddPassengers';//添加乘客
import PayDetail from './Shift/PayDetail';//支付页面
import Drivers from './Home/Index/Drivers';//司机
import Settings from '../container/Member/Settings';//设置
import ResetPassword from '../container/Member/resetPassword';//重置密码
import Version from '../container/Member/Version';//版本说明
import HistoryModule  from '../container/Member/HistoryModule';//历史记录

/*租车模块*/
import RentOrderList from './RentModule/RentOrderList';//租车记录
import RentConfirm from './RentModule/RentConfirm';//确认订单
import RentDetail from './RentModule/RentDetail';//订单详情
import RentRefund from './RentModule/RentRefund';//退款详情
/*城内分流相关路由 */
//组合发单
import CombinationBill from './CityService/CombinationBill';//重置密码
import BillView from './CityService/BillView';//发单预览
import Dispatch from './CityService/Dispatch';//派单调度
/*城内业务路由 */
import CityDispatcher from './Home/changeRole/City/CityDispatcher';
import CityBill from './Home/changeRole/City/CityBill';
import CityConfirm from './Home/changeRole/City/CityConfirm';
import CityWorking from './Home/changeRole/City/CityWorking';
/*城内相关路由 */
/*接驳业务*/
import PickWorking from './Home/changeRole/Pick/PickWorking';
import PickDispatcher from './Home/changeRole/Pick/PickDispatcher';
import PickBill from './Home/changeRole/Pick/PickBill';
import ProgressDetail from './Home/changeRole/Pick/ProgressDetail';
/*接驳业务*/
import CityBillView from './CityDispatch/CityBillView';//发单预览
/*以前版本的路由，暂时不删除 */


//帮助中心
import HelpCenter from '../container/Member/HelpCenter';
//乘车须知
import RidingKnow from '../container/Member/HelpCenter/RidingKnow';
//退票收费
import TicketRefund from '../container/Member/HelpCenter/ticketRefund';
//关于民途
import AboutMintu from '../container/Member/HelpCenter/AboutMintu';
//起止区域价格
import LinePrice from '../container/Member/HelpCenter/LinePrice';
//实名购票
import RealName from '../container/Member/HelpCenter/RealName';
//发票申请
import InvoiceApply from '../container/Member/HelpCenter/InvoiceApply';
//分享好友
import Share from '../container/Member/Share';
import Regulation from '../container/Member/Regulation';
import InviteAdd from '../container/Member/InviteAdd';
//2021-10-18自检单
import AuditInspection from '../container/Home/AuditInspection';//自检单审核列表
import AuditDetail from '../container/Home/AuditInspection/AuditDetail';//自检单审核详情
import BatchDeleteClass from '../container/Home/BatchDeleteClass';//批量删除排班

export default class App extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {
        setNavigateToLogin(() => {
            //document.location = `/login`;
        });
    }

    render() {
        return (
            <Switch>
                <Route path="/batchDeleteClass" component={BatchDeleteClass}/>
                <Route path="/auditDetail" component={AuditDetail}/>
                <Route path="/auditInspection" component={AuditInspection}/>
                <Route path="/refundApply" component={RefundApply}/>
                {/*  <Route path="/refundApply/:orderNo" component={RefundApply}/>*/}
                <Route path="/dataStatistics" component={DataStatistics}/>
                <Route path="/dealList" component={DealList}/>
                <Route path="/dealDetail" component={DealDetail}/>
                <Route path="/waterBill" component={WaterBill}/>
                <Route path="/shuntOrder" component={ShuntOrder}/>
                <Route path="/news" component={News}/>
                <Route path="/selectAddress" component={SelectAddress}/>
                <Route path="/pickHistory" component={PickHistory}/>
                <Route path="/inviteAdd/:userId" component={InviteAdd}/>
                <Route path="/regulation" component={Regulation}/>
                <Route path="/share" component={Share}/>
                <Route path="/drivers" component={Drivers}/>
                <Route path='/bringGoodList' component={BringGoodList}/>
                <Route path="/addShift" component={AddShift}/>
                <Route path="/passengerList" component={PassengerList}/>
                <Route path="/shiftDetails/:id" component={ShiftDetails}/> 
                <Route path="/addPassengers" component={AddPassengers}/>
                <Route path="/payDetail" component={PayDetail}/>
                <Route path="/login" component={Login}/>
                <Route path="/home" component={Home}/>
                <Route path="/settings" component={Settings}/>
                <Route path="/historyModule" component={HistoryModule}/>
                <Route path="/version" component={Version}/>
                <Route path="/resetPassword" component={ResetPassword}/>
                <Route path="/aboutMintu" component={AboutMintu}/>
                <Route path="/linePrice" component={LinePrice}/>
                <Route path="/realName" component={RealName}/>
                <Route path="/invoiceApply" component={InvoiceApply}/>
                <Route path="/ridingKnow" component={RidingKnow}/>
                <Route path="/ticketRefund" component={TicketRefund}/>
                <Route path="/helpCenter" component={HelpCenter}/>
                <Route path="/resetPwd" component={ResetPwd}/>
                <Route path="/getCode" component={GetCode}/>
                <Route path="/setPwd" component={SetPwd}/>
                <Route path="/cityDispatcher" component={CityDispatcher}/>
                <Route path="/cityBill" component={CityBill}/>
                <Route path="/cityConfirm" component={CityConfirm}/>
                <Route path="/CityWorking" component={CityWorking}/>
                {/*租车模块 */}
                <Route path="/rentConfirm" component={RentConfirm}/>
                <Route path="/rentDetail" component={RentDetail}/>
                <Route path="/rentRefund" component={RentRefund}/>
                <Route path="/rentOrderList" component={RentOrderList}/>
                {/*接驳业务*/}
                <Route path="/pickWorking" component={PickWorking}/>
                <Route path="/PickDispatcher" component={PickDispatcher}/>
                <Route path="/pickBill" component={PickBill}/>
                <Route path="/progressDetail" component={ProgressDetail}/>
                
                {/*<Route path="/paperInvoice/:id" component={paperInvoice}/>*/}
                <Route path="/paperInvoice" component={paperInvoice}/>
                <Route path="/invoiceHistory" component={InvoiceHistory}/>
                <Route path="/invoiceSucceed" component={InvoiceSucceed}/>
                <Route path="/invoiceInfo" component={InvoiceInfo}/>
                <Route path="/invoice" component={Invoice}/>
                <Route path="/applyInvoice" component={ApplyInvoice}/>
                <Route path="/selAddress" component={SelAddress}/>
                <Route path="/changeAddress" component={ChangeAddress}/>
                <Route path="/twoDimensionalCode" component={TwoDimensionalCode}/>
                <Route path="/twoDimensional" component={TwoDimensional}/>
                <Route path="/paySuccess" component={PaySuccess}/>
                <Route path="/refundTicket" component={RefundTicket}/>
                <Route path="/frequentlyPassenger" component={FrequentlyPassenger}/>
                <Route path="/addfrequentlyPassenger" component={AddFrequentlyPassenger}/>
                <Route path="/replaceOrderList" component={ReplaceOrderList}/>
                <Route path="/historyShift" component={HistoryShift}/>
                <Route path="/shuntOrderList" component={ShuntOrderList}/>
                <Route path="/cityOrderList" component={CityOrderList}/>
                <Route path="/shuntList" component={ShuntList}/>
                <Route path="/replaceOrderInfo" component={ReplaceOrderInfo}/>
                <Route path="/passengerInfo" component={PassengerInfo}/>
                <Route path="/selectShift" component={SelectShift}/>
                <Route path="/orderChange" component={OrderChange}/>

                 {/*城内分流路由*/}
                <Route path="/combinationBill" component={CombinationBill}/>
                <Route path="/billView" component={BillView}/>
                <Route path="/dispatch" component={Dispatch}/>
                {/*城内路由*/}
                <Route path="/cityBillView" component={CityBillView}/>
                <Route path="/" render={() => <Redirect to="/home"/>}/>
            </Switch>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/App.js